import {ScrollTrigger} from "gsap/ScrollTrigger.js";

/**
 * Content above scroll-driven sections can change height after init (lazy images, fonts, mobile layout) —
 * ScrollTrigger would keep stale start/end. Re-measure (debounced) whenever the page height changes.
 * Safe to call from several components: the observer is created once.
 */
let watching = false;

export const watchPageHeight = () => {
    if (watching || typeof ResizeObserver === 'undefined') return;
    watching = true;

    let lastHeight = document.body.scrollHeight;
    let timeout;
    new ResizeObserver(() => {
        const height = document.body.scrollHeight;
        if (Math.abs(height - lastHeight) < 2) return;
        lastHeight = height;
        clearTimeout(timeout);
        timeout = setTimeout(() => ScrollTrigger.refresh(), 150);
    }).observe(document.body);
};
